<template>
    <div class="content">
        <div class="container-fluid">
            <h3 class="m-0" style="margin-bottom: 10px !important">Area Mitra</h3>
            <div class="row">
                <div class="col-md-6">
                    <button class="btn btn-primary" @click="data.modalTambahan = true">Tambah Area</button>
                </div>
                <div class="col-md-12">
                    <div class="card mt-3">
                        <div class="card-body">
                            <div class="table-responsive">
                            <table class="table">
                                <thead class=" text-info">
                                    <th width="40px">No.</th>
                                    <th>Nama</th>
                                    <th width="100px">Aksi</th>
                                </thead>
                                <tbody v-show="!data.loading">
                                    <tr v-for="(u, index) in theGet.data.List">
                                        
                                        <td>{{ index+1 }}</td>
                                        <td>{{ u.nama }}  </br> </td>
                                        <td>
                                            <button v-if="myGlobal.RootOnly()" class="btn btn-sm btn-danger" title="Download Invoice"  @click="data.modalHapus = true;data.namaHapus = u.nama;data.idHapus = u.id"><span class="material-icons">delete_outline</span></button>
                                        </td>
                                    </tr>
                                    <tr v-if="theGet.data.List == null">
                                        <td></td>
                                        <td>Tidak ada Data </td>
                                    </tr>
                                </tbody>
                                <tbody v-show="data.loading">
                                    <tr>
                                        <td colspan="3"><Loading></Loading></td>
                                    </tr>
                                    <tr>
                                        <td colspan="3"><Loading></Loading></td>
                                    </tr>
                                    <tr>
                                        <td colspan="3"><Loading></Loading></td>
                                    </tr>
                                </tbody>
                            </table>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>

            <!-- MODAL -->
            <div class="modal" tabindex="-1" role="dialog" v-show="data.modalHapus">
                <div class="overlay"></div>
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Hapus Mitra</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="data.modalHapus = false">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label class="bmd-label-floating">Hapus Area Mitra "{{data.namaHapus}}"?</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-success" @click="data.modalHapus = false">Batal</button>
                            <button type="button" class="btn btn-secondary" @click="data.modalHapus = false,theGet.hapus()">Hapus</button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- MODAL TAMBAHAN -->
            <div class="modal" tabindex="-1" role="dialog" v-show="data.modalTambahan">
                <div class="overlay"></div>
                <div class="modal-dialog" role="document"  style="max-width: 800px;">
                    <div class="modal-content" style="width: 800px;">
                        <div class="modal-header">
                            <h5 class="modal-title">Tambah Area</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="data.modalTambahan = false">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="mb-3">
                                <div class="form-group">
                                    <label class="bmd-label-floating">Nama</label>
                                    <input type="text" class="form-control" placeholder="Nama Area Mitra..." v-model="data.nama">
                                    <label class="bmd-label-floating text-danger"  v-show="data.alert">{{data.alertText}}</label>
                                </div>
                                <span>
                                    <button class="btn btn-sm btn-info" @click="theGet.simpanArea()">Simpan</button>
                                    <button class="btn btn-sm btn-secondary" @click="data.modalTambahan = false">Batal</button>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import vuejsDatepicker from 'vuejs-datepicker'
import moment from 'moment'

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 
import { urlAssets } from '@/var/var.js'
import Loading from '@/globalFunc/Loading' 

Vue.use(moment)

export default {
    name: 'Beranda',
    components: { 
        "Loading" : Loading
        
    }, 
    setup() {
        const data = reactive({
            modalHapus: false,
            namaHapus: null,
            modalTambahan: false,
            idHapus: null,
            nama: null,
            alert: false,
            alertText: null,
            loading: true
        })

        const theGet = {
            data: reactive({
                List: [],
            }),
            datae() {

                var datax = {
                    token: 'TangTung '+sessionStorage.getItem('myToken')
                };

                data.lunasTotal = 0;
                    
                var apiUrl = inter.MitraArea();
                myGlobal.call(datax,apiUrl).then(x => {

                    //console.log(JSON.stringify(x));
                    
                    if (x.status == true) {
                        this.data.List = x.data;
                        
                        

                    } else {
                        
                    }

                    data.loading = false;
                })
            },
            hapus() {
                
                data.loading = true;
                
                var datac = data;

                var datax = {
                    token: 'TangTung '+sessionStorage.getItem('myToken'),
                    id: datac.idHapus,
                }
				
                var apiUrl = inter.MitraAreaHapus();
				
				myGlobal.call(datax,apiUrl).then(x => {

                    //console.log(JSON.stringify(x))

					if (x.status) {
                        
                        setTimeout(() => { 
                            
                            theGet.datae();

                        }, 500);

					} else {

					}
				})
            },
            simpanArea() {
                let nama = data.nama;

                if(nama == null) {
                    data.alert = true;
                    data.alertText = "Nama tidak boleh kosong";

                    return;
                }

                data.modalTambahan = false;
                
                data.loading = true;

                data.alert = false;

                var datax = {
                    token: 'TangTung '+sessionStorage.getItem('myToken'),
                    nama: nama
                }
				
                var apiUrl = inter.MitraAreaSimpan();
				
				myGlobal.call(datax,apiUrl).then(x => {

                    //console.log(JSON.stringify(x))

					if (x.status) {

                        setTimeout(() => { 

                            theGet.datae();

                        }, 500);

					} else {

					}
				})



            }
        }

        return {
            data, 
            theGet,
            myGlobal
        }

    },
    mounted () {
        document.title = "Area Mitra";

        this.data.bulan =  myGlobal.getBulan();

        setTimeout(() => { 

            this.theGet.datae();

        }, 500);

        this.data.dis = this;
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.modal {
	display: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/mitra/area.vue